import React from "react";
import Title from "../../../components/Title";
import util from "../../../assets/roadmap-util1.png";
const Roadmap = () => {
  class DataObj {
    constructor(title, listText) {
      this.title = title;
      this.listText = listText;
    }
  }

  const data = [
    new DataObj("Phase I", [
      "Website/Token/Staking Deploy",
      "Techrate Audit",
      "CMC + CG Listings",
      "1000 Wallet Holders",
      "10M Market Cap",
    ]),
    new DataObj("Phase II", [
      "Showcase Character Options",
      "2500 Wallet Holders",
      "12,500 Community Members",
      "25M Market Cap",
      "First Kings Event",
    ]),
    new DataObj("Phase III", [
      "NFT Ticket Release",
      "Top CEX Listings",
      "10,000 Wallet Holders",
      "50,000 Community Members",
      "100M Market Cap",
    ]),
    new DataObj("Phase IV", [
      " Open Codename Beta",
      "VIP Exclusive Rewards",
      "50,000 Wallet Holders",
      "250K Community Members",
      "1B Market Cap",
    ]),
  ];

  return (
    <div>
      <div className="container py-20" id="roadmap">
        <Title text={"Road Map"} image={util} center />
        <div className="mt-20 max-w-[800px] mx-auto  sm:block hidden">
          {data.map((val, i) => (
            <div key={i} className="grid grid-cols-12 ">
              <div className=" col-span-5 flex mb-10 items-center">
                {i % 2 === 0 && (
                  <>
                    <div className="roadmap-box p-4">
                      {val.listText.map((value, index) => (
                        <p>{value}</p>
                      ))}
                    </div>
                    <h4 className=" shrink-0 ml-2 text-primary">{val.title}</h4>
                  </>
                )}
              </div>
              <div className="col-span-2">
                <div className="bg-primary h-full w-[2px] rounded-full mx-auto relative">
                  {" "}
                  <div className="bg-white h-4 w-4 rounded-full absolute top-1/2  -translate-y-1/2 -mt-5 -translate-x-1/2 left-1/2"></div>{" "}
                </div>
              </div>
              <div className=" col-span-5 flex mb-10 items-center">
                {i % 2 === 1 && (
                  <>
                    <h4 className=" shrink-0 mr-2 text-primary">{val.title}</h4>
                    <div className="roadmap-box p-4">
                      {val.listText.map((value, index) => (
                        <p>{value}</p>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="grid gap-10 mt-10 md:hidden">
          {data.map((val, i) => (
            <div key={i} className="roadmap-box p-4 ">
              <b className="text-xl block mb-2">{val.title}</b>
              {val.listText.map((value, index) => (
                <p>{value}</p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Roadmap;
